import classnames from 'classnames';

export const classes = (component: string, ...classNames: (string | undefined)[]) =>
    classnames(`elc-${component}`, `js-${component}`, classNames);

//class name
const classPrefix = 'elc-iam';

export const fieldClasses = (name: string, type: string) => {
    const commonClass = `${classPrefix}-${type}`;
    const customClassName = `${commonClass}-${name}`;

    return `${commonClass} ${customClassName}`;
};

//generate classes for Field Label
export const fieldLabelClasses = (name: string, isRequired: boolean | undefined = false) => {
    const labelClasses = fieldClasses(name, 'label');

    const requiredLabelClass = `${classPrefix}-label-required`;
    const requiredLabelClassName = `${isRequired ? requiredLabelClass : ''}`;

    return `${labelClasses} ${requiredLabelClassName}`;
};

//generate classes of Text Component
export const textFieldClasses = (name: string) => {
    return fieldClasses(name, 'text');
};

//generate classes of Text Input Component
export const textInputFieldClasses = (name: string) => {
    return fieldClasses(name, 'textInput');
};

//generate classes of dropdown Component
export const dropdownFieldClasses = (name: string) => {
    return fieldClasses(name, 'dropdown');
};

//generate classes for 'select all' check of checkbox group Component
export const ckGroupSelectAllWrapperClasses = (name: string) => {
    return fieldClasses(name, 'checkboxGroup-selectAll');
};

export const ckGroupItemWrapperClasses = (name: string) => {
    return fieldClasses(name, 'checkboxGroup-item');
};

export const ckClasses = (name: string) => {
    return fieldClasses(name, 'checkbox');
};

export const textInputDataListClasses = (name: string) => {
    return fieldClasses(name, 'textInput-dataList');
};

export const submitButtonClassNames = classes('iam-submit-button');
export const submitButtonWrapperClassNames = classes('iam-submit-button-wrapper');
export const formWrapperClassName = 'elc-iam-form-wrapper';
export const formTitleClassName = 'elc-iam-form-title';
export const formSubtitleClassName = 'elc-iam-form-subtitle';
export const formClassName = 'elc-iam-form';
